import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_RESET_CANDIDATE_STEP = gql`
    mutation OnboardingResetCandidateStep($request: ResetCandidateStepRequestDto) {
        onboardingResetCandidateStep(request: $request) {
            uuid
            step
            resetComment
            
        }
    }
`;

const useOnboardingResetCandidateStep = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_RESET_CANDIDATE_STEP);

    const resetCandidateStep = async (candidateUuid, step, resetComment) => {
        return mutate({
            variables: {
                request: {
                    candidateUuid,
                    step,
                    resetComment: resetComment || null,
                },
            },
        });
    };

    return {
        resetCandidateStep,
        loading,
        error,
    };
};

export default useOnboardingResetCandidateStep;
